export default __webpack_public_path__ + "static/media/avatars.88316112.webp";